<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>am{{$t('yhgl')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="search">
                        <div class="searchleft">
                            <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                                <el-form-item :label="$t('gjz')">
                                    <el-input v-model="searchform.blurry" @keyup.enter.native="onSubmit" size="small" :placeholder="$t('qddh')">
                                    </el-input>
                                </el-form-item>
                                <!-- <el-form-item :label="$t('yhzt')">
                                    <el-select size="small" v-model="searchform.stas" style="width:170px;" :placeholder="$t('qxzyhzt')"  >
                                        <el-option :label="$t('buxian')" :value="null"></el-option>
                                        <el-option :label="$t('drz')" :value="0"></el-option>
                                        <el-option :label="$t('rzz')" :value="1"></el-option>
                                        <el-option :label="$t('dqy')" :value="2"></el-option>
                                        <el-option :label="$t('shz')" :value="3"></el-option>
                                        <el-option :label="$t('shjj')" :value="4"></el-option>
                                        <el-option :label="$t('fksb')" :value="5"></el-option>
                                        <el-option :label="$t('jj')" :value="6"></el-option>
                                        <el-option :label="$t('wdq')" :value="7"></el-option>
                                        <el-option :label="$t('dqr')" :value="8"></el-option>
                                        <el-option :label="$t('yq')" :value="9"></el-option>
                                    </el-select>
                                </el-form-item> -->
                                <el-form-item :label="$t('pingt')">
                                    <el-input v-model="searchform.platform" size="small" style="width: 150px;">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="clabe">
                                    <el-input v-model="searchform.clabe" size="small" style="width: 150px;">
                                    </el-input>
                                </el-form-item>
                                <el-form-item :label="$t('time')">
                                    <el-date-picker
                                    v-model="value1"
                                    type="datetimerange"
                                    size="small"
                                    @change="checkdata"
                                    range-separator="至"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    start-placeholder="开始时间"
                                    end-placeholder="结束时间">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item>
                                    <el-button size="small" type="primary" @click="onSubmit">查询</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <el-table :data="list"
                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" stripe border style="width: 100%">
                        <el-table-column prop="phone" :label="$t('phone')"></el-table-column>
                        <el-table-column :label="$t('exclusiveLinks')" width="188px">
                            <template slot-scope="scope">
                                <el-button type="text" @click="queryLink(scope.row)">{{$t('c12')}}</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('c11')" width="188px">
                            <template slot-scope="scope">
                                <el-button type="text" @click="queryClabe(scope.row)">{{$t('c13')}}</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column prop="channel" :label="$t('channel')"></el-table-column>
                        <el-table-column prop="level" :label="$t('createTime')">
                            <template slot-scope="scope">
                                {{scope.row.createTime|changedate}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="level" :label="$t('zhdlsh')">
                            <template slot-scope="scope">
                                {{scope.row.loginTime|changedate}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="userStatus" :label="$t('status')">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.userStatus=='待认证'" type="info">{{$t('drz')}}</el-tag>
                                <el-tag v-if="scope.row.userStatus=='认证中'" type="info">{{$t('rzz')}}</el-tag>
                                <el-tag v-if="scope.row.userStatus=='待签约'" type="info">{{$t('dqy')}}</el-tag>
                                <el-tag v-if="scope.row.userStatus=='审核中'" type="info">{{$t('shz')}}</el-tag>
                                <el-tag v-if="scope.row.userStatus=='审核拒绝'" type="info">{{$t('shjj')}}</el-tag>
                                <el-tag v-if="scope.row.userStatus=='放款失败'" type="info">{{$t('fksb')}}</el-tag>
                                <el-tag v-if="scope.row.userStatus=='结清'" type="info">{{$t('jj')}}</el-tag>
                                <el-tag v-if="scope.row.userStatus=='未到期'" type="info">{{$t('wdq')}}</el-tag>
                                <el-tag v-if="scope.row.userStatus=='到期日'" type="info">{{$t('dqr')}}</el-tag>
                                <el-tag v-if="scope.row.userStatus=='逾期'" type="info">{{$t('yq')}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="platform" :label="$t('pingt')"></el-table-column>
                        <el-table-column prop="jobName" :label="$t('operator')" width="150">
                            <template slot-scope="scope">
                                <el-tooltip v-if="user.user.roles[0].id==1 && scope.row.userStatus!='待认证'" class="item" effect="dark" :content="$t('rzxx')" placement="top">
                                     <el-button size="small" @click="openextend(scope.row)"  type="primary" icon="el-icon-menu" circle plain></el-button>
                                </el-tooltip>
                                <el-tooltip v-if="user.user.roles[0].id==1 && scope.row.userStatus!='待认证'" class="item" effect="dark" content="修改身份证号码" placement="top">
                                    <el-button size="small" @click="openedit(scope.row)" type="primary" icon="el-icon-edit"
                                        circle plain style="margin-right:5px;"></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="page">
                        <app-page :total="total" :current="pageNo" :pageSize="pageSize"
                            @handleCurrentChange="currentchange" @handleSizeChange="handchange"></app-page>
                    </div>
                </div>
            </div>
        </div>
        <pop-up title="修改身份证号码" :isshow="showadd" :haveconfirm="true" @close="getclose" @confirm="getconfirm">
            <div slot="box">
                <el-form ref="form" :inline="true" :model="form" :rules="rules" size="small">
                    <el-form-item label="身份证号码" prop="idNumber">
                        <el-input v-model="form.idNumber" />
                    </el-form-item>
                </el-form>
            </div>
        </pop-up>
    </div>
</template>
<script>
    import apiurl from "@/api/sys"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                form: {
                    userId: null,
                    idNumber: null,
                },
                searchform: {
                    blurry: "",
                },
                defaultProps: {
                    label: "name",
                    isLeaf: 'isLeaf'
                },
                loading: false,
                showadd: false,
                list: [],
                value1:[],
                searchform:{},
                deptId:null,
                total: 1,
                pageNo: 1,
                pageSize: 10,
                keyword: '',
                depts: [],
                user:null,
                rolelist: [],
                status: 1,
                depts2: [],
                ceshi:""
            }
        },
        mounted() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            const name = this.user.user.username

            var date = new Date();
            var UTCTime = Date.now() + date.getTimezoneOffset() * 60 * 1000;
            const timeArr = UTCTime - 6 * 60 * 60 * 1000;
            const timeStr = this.formatTime(timeArr)
            this.addWatermark(`${name} ${timeStr}`)
        },
        created() {
            this.user = JSON.parse(localStorage.getItem("userinfo"))
            this.value1 = this.getNowTime()
            this.getList()
        },
        methods: {
            addWatermark(text) {
                const canvas = document.createElement('canvas')
                canvas.width = 300
                canvas.height = 200
                const ctx = canvas.getContext('2d')
                ctx.rotate(-20 * Math.PI / 180)
                ctx.font = '16px Arial'
                ctx.fillStyle = 'rgba(0,0,0,0.08)'
                ctx.fillText(text, 20, 100)
                const base64 = canvas.toDataURL()
                const div = document.createElement('div')
                div.style.position = 'fixed'
                div.style.top = '0'
                div.style.left = '0'
                div.style.width = '100%'
                div.style.height = '100%'
                div.style.pointerEvents = 'none'
                div.style.backgroundImage = `url(${base64})`
                div.style.zIndex = '9999'
                document.body.appendChild(div)
            },
            formatTime(timestamp) {
                const d = new Date(timestamp)
                const pad = (n) => n.toString().padStart(2, '0')

                return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} `
                    + `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
            },
            getNowTime() {
                const start = new Date(new Date().getTime() - 3600 * 1000 * 24 * 1)
                    .toISOString()
                    .replace('T', ' ')
                    .split('.')[0] //默认开始时间7天前
                const end = new Date(new Date().getTime())
                    .toISOString()
                    .replace('T', ' ')
                    .split('.')[0]//默认结束时间1天前
                return [start, end]
            },
            checkdata(){
                this.getList()
            },
            openedit(row) {
                this.showadd = true
                this.form.userId = row.id
                this.form.idNumber = row.idNumber
            },
            queryLink(row) {
                _api.get(apiurl.queryLink,{
                    userId: row.id,
                }).then(res => {
                        this.$alert(res.data, '还款链接', {
                        confirmButtonText: '确定',
                        callback: action => {
                            this.$message({
                                type: 'info',
                                message: `action: ${ action }`
                            });
                        }
                    });
                })
            },
            queryClabe(row) {
                _api.get(apiurl.queryClabe,{
                    userId: row.id,
                }).then(res => {
                        this.$alert(res.data, '还款账号', {
                        confirmButtonText: '确定',
                        callback: action => {
                            this.$message({
                                type: 'info',
                                message: `action: ${ action }`
                            });
                        }
                    });
                })
            },
            openextend(row){
                this.$router.push({path:"/userlist/extend",query:{id:row.id,phone:row.phone}})
            },
            getclose() {
                this.$refs.form.resetFields();
                this.showadd = false
            },
            getconfirm() {
                if(this.form.idNumber==null || this.form.idNumber==""){
                    this.$message.error('身份证号码不能不空')
                    return
                }
                _api.put(apiurl.updateUserIdNnumber, this.form).then(res => {
                    this.$notify.success({
                        title: this.$t('success'),
                        message: this.$t('editSuccess')
                    })
                    this.getList()
                    this.form = {
                        userId: null,
                        idNumber: null,
                    }
                    this.showadd = false
                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: err.data.message
                    })
                })
            },
            getList() {
                this.loading = true
                _api.get(apiurl.mcashuser, {
                    page: this.pageNo,
                    size: this.pageSize,
                    blurry: this.searchform.blurry,
                    createTime: this.value1,
                    stas: this.searchform.stas,
                    platform: this.searchform.platform,
                    nation:localStorage.getItem("nation"),
                    clabe: this.searchform.clabe,
                }).then(res => {
                    this.loading = false
                    this.list = res.content.list
                    this.total = res.content.total
                })
            },
            onSubmit() {
                this.pageNo = 1
                this.getList()
            },
            handchange(data) { //分页Size变化
                this.pageSize = data
                this.pageNo = 1
                this.getList()
            },
            currentchange(data) { //当前页变化
                this.pageNo = data
                this.getList()
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>